import VLazy from './VLazy';
export { VLazy };
export default VLazy;
//# sourceMappingURL=index.js.map